
import React from "react";
// import logoMain from '../images/MAAMAAS_LOGO_V1-01[1].png';
import hotelRoomImg1 from "../images/dine.jpg";
import hotelRoomImg2 from "../images/catering.jpg";
import hotelRoomImg3 from "../images/delevery.jpg";
import hotelRoomImg4 from "../images/gro.jpg";
// import hotelRoomImg5 from "../images/aaaservices/ride.jpg";
// import bannerImg from "../images/aaaservices/MAAMAAS_CARPET_V2-01[1].jpg";

const cardData = [
  {
    image: hotelRoomImg1,
    location: "Dine-in",
    description: "From fine dining and quick-service restaurants to cafes, bakeries, juice bars, and specialty food stores, Maamaas empowers you to showcase your menu with stunning visuals, manage orders seamlessly—including dine-in, takeaway, and delivery—and reach more customers in your area to grow your brand. Perfect for any business that serves delicious meals and drinks, Maamaas makes it easy to delight every customer while simplifying day-to-day operations.",
    bookingLink: "https://maamaas.com/",
  },
  {
    image: hotelRoomImg2,
    location: "Takeaway",
    description: "Whether you provide personal catering, corporate event catering, or operate a company cafeteria, Maamaas helps you present your catering packages and customized menu options to potential clients, accept bookings online effortlessly, and build trust through customer ratings and reviews. From private gatherings to large-scale corporate events, Maamaas ensures your services are showcased professionally and reach the right audience, helping your business stand out and grow.",
    bookingLink: "https://maamaas.com/",
  },
  {
    image: hotelRoomImg3,
    location: "Delivery",
    description: "From courier and delivery services to wholesale suppliers and inventory businesses, Maamaas streamlines your operations by managing orders efficiently, tracking deliveries and shipments in real time, and enabling smooth communication with customers and partners. Whether it’s rides, parcels, goods, or drivers using cycles, cars, or planes, Maamaas ensures your logistics run like clockwork, providing reliability and efficiency every step of the way.",
    bookingLink: "https://maamaas.com/",
  },
  {
    image: hotelRoomImg4,
    location: " Catering",
    description: "From courier and delivery services to wholesale suppliers and inventory businesses, Maamaas streamlines your operations by managing orders efficiently, tracking deliveries and shipments in real time, and enabling smooth communication with customers and partners. Whether it’s rides, parcels, goods, or drivers using cycles, cars, or planes, Maamaas ensures your logistics run like clockwork, providing reliability and efficiency every step of the way.",
    bookingLink: "https://maamaas.com/",
  },
  // {
  //   image: hotelRoomImg5,
  //    location: "Riders",
  //   description: "Marketplace for unique, handpicked products and brands,",
  //   bookingLink: "https://maamaas.com/",
  // },
];

const HotelFacilities = () => {
  return (
    <section id="what-we-do">
      <div className="main-container">
        <div className="logo-container">

        </div>
        <div style={{ textAlign: "center", marginTop: '-15px', maxwidth: '50%' }}>
          <h1 className="whylovemaamaas-gellery"
            style={{
              fontSize: "50px",
              fontFamily: "Lato, sans-serif",
              position: "relative",
              display: "inline-block",
              fontWeight: 'bold',
              color: "white"
            }}
          >
            Everything You Need,  <span style={{ color: "rgb(255 225 36)" }}> One Tap Away</span>
            <span
            // style={{
            //   position: "absolute",
            //   bottom: "-8px",
            //   left: "0",
            //   width: "50%",
            //   height: "2px",
            //   backgroundColor: "#000",
            // }}
            />
          </h1>
        </div>
        <div className="cards-container">
          {cardData.map((card, index) => (
            <div className="cardss" key={index}>
              <div className="image-container">
                <img src={card.image} alt={`Hotel ${index + 1}`} />

              </div>

              <div className="description">

                <p>{card.description}</p>

              </div>

              {/* <a
                href={card.bookingLink}
                target="_blank"
                rel="noopener noreferrer"
                className="book-now-btn"
              >
                Book Now
              </a> */}
              {/* <div className="location-overlays">{card.location}</div> */}
            </div>
          ))}
        </div>

        <style>{`
          .main-container {
          background-color:#2a0947;
            background-size: cover;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            color: #fff;
            text-align: center;
            padding: 20px;
            margin-top:30px;
          }

          .logo-container img {
            max-width: 511px;
            width: 114%;
            height: 346px;
          }

          .cards-container {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 20px;
            padding: 20px 0;
          }

          .cardss {
            background: #fff;
            border-radius: 20px;
            width: 270px;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow: hidden;
            padding: 20px 10px;
            color: #000;
            position: relative;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          }

          .image-container {
            position: relative;
            width: 100%;
            height: 180px;
          }

          .image-container img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 12px;
          }

          .location-overlays {
  position: absolute;
  bottom: 19px;
  left: 25%;
  transform: translateX(-50%);
 background: #2a0947;
  color: white;
  padding: 8px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: bold;

  z-index: 1;
  transition: background 0.3s, color 0.3s;
}

.location-overlay:hover {
  background: #ffbe64;
  color: black;
}


          .description {
            padding: 10px 0;
            font-size: 14px;
            text-align: center;
            min-height: 60px;
            font-wiget:bold;
            font-family:roboto;
          }

          .book-now-btn {
            margin-top: auto;
            padding: 8px 16px;
            background: #2a0947;
            color:rgb(255 225 36);
            border: none;
            border-radius: 8px;
            font-size: 14px;
            font-weight: bold;
            cursor: pointer;
            transition: background-color 0.3s ease;
            text-decoration: none;
             margin-left:137px;
          }

          .book-now-btn:hover {
            background-color:#462053;
            color: white;
          }

          @media (max-width: 768px) {
            .cardss {
              width: 100%;
            }

            .logo-container img {
              width: 100%;
              height: auto;
            }
          }
        `}</style>
      </div>
    </section>
  );
};

export default HotelFacilities;